export default [
    {
        title: 'Dashboard',
        route: 'company.dashboard',
        icon: 'home',
    },

    // {
    //     title: 'Sign',
    //     icon: 'signing-a-document',

    //     children: [
    //         {
    //             title: 'Pre-incorporation',
    //             route: 'pre-incorporation',
    //             icon: 'pre-documents',
    //         },
    //         {
    //             title: 'Incorporation',
    //             route: 'incorporation',
    //             icon: 'papers',
    //         },
    //         {
    //             // in here transfer means company transfer and process is secretary-appointment
    //             title: 'Transfer',
    //             route: 'secretary-appointment',
    //             icon: 'secretary-appointment',
    //         },
    //         {
    //             title: 'Change of FYE',
    //             route: 'change-of-fye',
    //             icon: 'calendar-pen',
    //         },
    //         {
    //             title: 'Director Fee',
    //             route: 'director-fee',
    //             icon: 'director-with-dollar',
    //         },
    //         {
    //             title: 'Director Changes',
    //             route: 'director-changes',
    //             icon: 'director-changes',
    //         },
    //         {
    //             title: 'Nominator Changes',
    //             route: 'nominator-changes-documents',
    //             icon: 'change-nominator',
    //         },
    //         {
    //             title: 'Update of Particulars',
    //             route: 'update-of-particulars-documents',
    //             icon: 'update-particulars',
    //         },
    //         {
    //             title: 'Auditor Changes',
    //             route: 'auditor-changes',
    //             icon: 'change-of-auditor',
    //         },
    //         {
    //             title: 'Secretary Resignation',
    //             route: 'secretaries-resignation-documents',
    //             icon: 'female_x5F_chinese',
    //         },
    //         {
    //             title: 'DPO',
    //             route: 'data-protection-officers-documents',
    //             icon: 'officer',
    //         },
    //         {
    //             title: 'Change of RO',
    //             route: 'change-ro',
    //             icon: 'setting-map-location-icon',
    //         },
    //         {
    //             title: 'Change of CO Name',
    //             route: 'change-of-company-name-documents',
    //             icon: 'change-company-name',
    //         },
    //         {
    //             title: 'Annual Return',
    //             route: 'annual-return',
    //             icon: 'annual-return',
    //         },
    //         {
    //             title: 'Interim Dividend',
    //             route: 'interim-dividend',
    //             icon: 'interim-dividend',
    //         },
    //         {
    //             title: 'AGM',
    //             route: 'agm',
    //             icon: 'annual-year',
    //         },
    //         {
    //             title: 'AGM Dispensation',
    //             route: 'agm-dispensation-documents',
    //             icon: 'annual-report',
    //             width: '13px',
    //         },
    //         {
    //             title: 'Allotment',
    //             route: 'allotment-documents',
    //             icon: 'allotment',
    //         },
    //         {
    //             title: 'Share Transfer',
    //             route: 'transfer-documents',
    //             icon: 'transfer',
    //         },
    //         {
    //             title: 'Share Cancellation',
    //             route: 'share-cancellation-documents',
    //             icon: 'minus-circle',
    //         },
    //         {
    //             title: 'Share Buy Back',
    //             route: 'share-buy-back-documents',
    //             icon: 'cash-back',
    //         },
    //         {
    //             title: 'Update Paid Up Capital',
    //             route: 'update-paid-up-capital-documents',
    //             icon: 'allotment',
    //         },
    //         {
    //             title: 'Strike Off',
    //             route: 'strike-off',
    //             icon: 'cancel',
    //         },
    //         {
    //             title: 'Business Activities',
    //             route: 'business-activities',
    //             icon: 'task-setting',
    //         },
    //         {
    //             title: 'Sale of Property',
    //             route: 'sale-of-property',
    //             icon: 'sale-property',
    //         },
    //     ]
    // },
    {
        title: 'Sign',
        icon: 'signing-a-document',

        children: [
            
            {
                title: 'Pre-incorporation',
                route: 'pre-incorporation',
                icon: 'pre-documents',
            },
            {
                title: 'Incorporation',
                route: 'incorporation',
                icon: 'papers',
            },
            {
                title: 'Transfer',
                route: 'secretary-appointment',
                icon: 'secretary-appointment',
            },
            {
                title: 'AGM',
                route: 'agm',
                icon: 'annual-year',
            },
            {
                title: 'AGM Dispensation',
                route: 'agm-dispensation-documents',
                icon: 'annual-report',
                width: '13px',
            },
            {
                title: 'Annual Return',
                route: 'annual-return',
                icon: 'annual-return',
            },
            {
                title: '△Auditor',
                route: 'auditor-changes',
                icon: 'change-of-auditor',
            },
            {
                title: '△Business Activities',
                route: 'business-activities',
                icon: 'task-setting',
            },
            {
                title: '△Company Name',
                route: 'change-of-company-name-documents',
                icon: 'change-company-name',
            },
            {
                title: '△Director',
                route: 'director-changes',
                icon: 'director-changes',
            },
            {
                title: '△FYE',
                route: 'change-of-fye',
                icon: 'calendar-pen',
            },
            {
                title: '△Nominator',
                route: 'nominator-changes-documents',
                icon: 'change-nominator',
            },
            {
                title: '△RO',
                route: 'change-ro',
                icon: 'setting-map-location-icon',
            }, 
            {
                title: 'Director Fee',
                route: 'director-fee',
                icon: 'director-with-dollar',
            },
            {
                title: 'DPO',
                route: 'data-protection-officers-documents',
                icon: 'officer',
            },
            {
                title: 'Interim Dividend',
                route: 'interim-dividend',
                icon: 'interim-dividend',
            },
            {
                title: 'Sale of Property',
                route: 'sale-of-property',
                icon: 'sale-property',
            },
            {
                title: 'Secretary Resignation',
                route: 'secretaries-resignation-documents',
                icon: 'female_x5F_chinese',
            },  
            {
                title: 'Share Allotment',
                route: 'allotment-documents',
                icon: 'allotment',
            },
            {
                title: 'Share Buy Back',
                route: 'share-buy-back-documents',
                icon: 'cash-back',
            },
            {
                title: 'Share Reduction',
                route: 'share-cancellation-documents',
                icon: 'minus-circle',
            },
            {
                title: 'Share Transfer',
                route: 'transfer-documents',
                icon: 'transfer',
            },
            {
                title: 'Strike Off',
                route: 'strike-off',
                icon: 'cancel',
            },
            {
                title: 'Update of Particulars',
                route: 'update-of-particulars-documents',
                icon: 'update-particulars',
            },
            {
                title: 'Update Paid Up Capital',
                route: 'update-paid-up-capital-documents',
                icon: 'allotment',
            },
            
           
        ]
    },
];
